import { render, staticRenderFns } from "./PreventiveAction.vue?vue&type=template&id=9dcf0a78&scoped=true&"
import script from "./PreventiveAction.vue?vue&type=script&lang=js&"
export * from "./PreventiveAction.vue?vue&type=script&lang=js&"
import style0 from "./PreventiveAction.vue?vue&type=style&index=0&id=9dcf0a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcf0a78",
  null
  
)

export default component.exports